import { cdnApiInstance } from "api/instance";
import { AxiosProgressEvent } from "axios";

export const uploadFile = (
  file: File,
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
): Promise<{ id: string; hash: string; mimeType: string }> => {
  const formData = new FormData();

  formData.append("file", file, file.name);

  return cdnApiInstance({ method: "post", data: formData, onUploadProgress })
    .then<{
      id: string;
      createdAt: string;
      name: string;
      size: number;
      mimeType: string;
      hash: string;
    }>((response) => response.data)
    .then((response) =>
      Promise.resolve({
        id: response.id,
        hash: response.hash,
        mimeType: response.mimeType,
      })
    )
    .catch((e) => {
      return Promise.reject(e);
    });
};
